import { render, staticRenderFns } from "./registro_edicion_porcentaje.vue?vue&type=template&id=f4797ff6&scoped=true"
import script from "./registro_edicion_porcentaje.vue?vue&type=script&lang=js"
export * from "./registro_edicion_porcentaje.vue?vue&type=script&lang=js"
import style0 from "./registro_edicion_porcentaje.vue?vue&type=style&index=0&id=f4797ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4797ff6",
  null
  
)

export default component.exports